export const STORE_MENU_LIST = 'store/menu-list'
export const STORE_MENU_TREE = 'store/menu-tree'
